import React from 'react'
import { Box, Typography, Button, Stack, Paper } from '@mui/material'
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded'
import { useNavigate } from 'react-router-dom'

export default function ErrorPage({ error, resetErrorBoundary }) {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 6,
          borderRadius: 4,
          maxWidth: 560,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 90,
            height: 90,
            borderRadius: '50%',
            bgcolor: 'rgba(211, 47, 47, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            mb: 3,
          }}
        >
          <ReportProblemRoundedIcon sx={{ fontSize: 52, color: 'error.main' }} />
        </Box>

        <Typography variant="h4" fontWeight={700} mb={1}>
          Something Went Wrong
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={3}>
          An unexpected error occurred. You can retry or reload the page.
        </Typography>

        {error.message && (
          <Typography
            variant="body2"
            sx={{
              bgcolor: 'grey.100',
              border: '1px solid',
              borderColor: 'grey.300',
              p: 2,
              borderRadius: 2,
              fontFamily: 'monospace',
              my: 3,
              color: 'error.main',
              whiteSpace: 'pre-wrap',
            }}
          >
            {error.message}
          </Typography>
        )}

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="center"
          sx={{ mt: 2 }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => navigate('/')}
            sx={{ textTransform: 'none', px: 4, borderRadius: 2 }}
          >
            Go To Home
          </Button>

          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={resetErrorBoundary}
            sx={{ textTransform: 'none', px: 4, borderRadius: 2 }}
          >
            Try Again
          </Button>
        </Stack>
      </Paper>
    </Box>
  )
}
